import React from 'react';
import { motion } from 'framer-motion';
import { Apple, Smartphone, Shield, Download, Star } from 'lucide-react';

const DownloadSection = () => {
  return (
    <section id="download" className="py-16 sm:py-24 md:py-32 relative overflow-hidden" data-testid="download-section">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-primary/10 to-transparent pointer-events-none" />
      
      <div className="max-w-5xl mx-auto px-4 sm:px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="glass-card p-6 sm:p-8 md:p-12 text-center relative overflow-hidden"
        >
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-32 sm:w-64 h-32 sm:h-64 bg-primary/20 rounded-full blur-[80px]" />
          <div className="absolute bottom-0 left-0 w-32 sm:w-64 h-32 sm:h-64 bg-[#10B981]/20 rounded-full blur-[80px]" />
          
          <div className="relative z-10">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }}
              className="w-14 h-14 sm:w-20 sm:h-20 rounded-xl sm:rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center mx-auto mb-6 sm:mb-8 glow-purple"
            >
              <Download className="w-7 h-7 sm:w-10 sm:h-10 text-white" />
            </motion.div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4 sm:mb-6">
              Ready to
              <span className="text-gradient"> Get Started?</span>
            </h2>
            
            <p className="text-base sm:text-lg text-slate-400 max-w-xl mx-auto mb-8 sm:mb-10 px-4">
              Download 2A Valuence today and transform how you price devices and manage repairs.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-8 sm:mb-10">
              {/* App Store Button */}
              <a
                href="https://apps.apple.com/app/id6759179016"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-white text-black rounded-xl hover:bg-slate-100 transition-colors duration-200 group w-full sm:w-auto justify-center"
                data-testid="download-app-store-btn"
              >
                <Apple className="w-6 h-6 sm:w-8 sm:h-8" />
                <div className="text-left">
                  <div className="text-[10px] sm:text-xs">Download on the</div>
                  <div className="text-base sm:text-lg font-semibold">App Store</div>
                </div>
              </a>

              {/* Google Play Button (Coming Soon) */}
              <div
                className="flex items-center gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-white/10 text-white rounded-xl border border-white/20 cursor-not-allowed opacity-70 w-full sm:w-auto justify-center"
                data-testid="download-google-play-btn"
              >
                <Smartphone className="w-6 h-6 sm:w-8 sm:h-8" />
                <div className="text-left">
                  <div className="text-[10px] sm:text-xs text-slate-400">Coming Soon</div>
                  <div className="text-base sm:text-lg font-semibold">Google Play</div>
                </div>
              </div>
            </div>

            {/* Badges */}
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
              <div className="flex items-center gap-2 text-slate-400">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-white/5 flex items-center justify-center">
                  <Star className="w-3 h-3 sm:w-4 sm:h-4 text-yellow-400" />
                </div>
                <span className="text-xs sm:text-sm">Version 1.2.0</span>
              </div>
              
              <div className="flex items-center gap-2 text-slate-400">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-white/5 flex items-center justify-center">
                  <Download className="w-3 h-3 sm:w-4 sm:h-4 text-primary" />
                </div>
                <span className="text-xs sm:text-sm">Free Download</span>
              </div>
              
              <div className="flex items-center gap-2 text-slate-400">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-white/5 flex items-center justify-center">
                  <Shield className="w-3 h-3 sm:w-4 sm:h-4 text-[#10B981]" />
                </div>
                <span className="text-xs sm:text-sm">Secure & Private</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DownloadSection;
